import { render, staticRenderFns } from "./ReflectHorizontal.vue?vue&type=template&id=2190fd86"
import script from "./ReflectHorizontal.vue?vue&type=script&lang=js"
export * from "./ReflectHorizontal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports